<app-main-menu></app-main-menu>
<div class="content">
    <p-panel styleClass="margin-top-10">
        <ng-template pTemplate="icons">
            <button pButton pRipple class="p-panel-header-icon p-link" (click)="homeUrlNav()" icon="pi pi-home">
            </button>
        </ng-template>
        <ng-template pTemplate="header">
            DANH SÁCH NHÂN SỰ
        </ng-template>
        <div class="card">
            <p-table [paginator]="true" [rows]="pageSize" [totalRecords]="totalRecords" [loading]="loading"
                [lazy]="true" [rowsPerPageOptions]="[10,25,50]" [value]="data" [(first)]="pageNumber"
                styleClass="p-datatable-sm" (onLazyLoad)="getNhanSu($event)">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Họ và tên</th>
                        <th>Là công chứng viên</th>
                        <th style="width: 120px;text-align: center;">#</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-data>
                    <tr>
                        <!-- <td>{{data.id}}</td> -->
                        <td>{{data.hovaten}}</td>
                        <td>{{data.lacongchungvien>0?'Công chứng viên':''}}

                        </td>
                        <td style="width: 100px;text-align: center;">
                            <button pButton pRipple type="button" icon="pi pi-user-edit"
                                class="p-button-rounded p-button-outlined" (click)="showEditNhanSu(data.id)"></button>
                            <button pButton pRipple type="button" icon="pi pi-key"
                                class="p-button-rounded p-button-outlined p-ml-2"
                                (click)="showChangePassword(data.id)"></button>
                            <button pButton pRipple type="button" icon="pi pi-trash"
                                class="p-button-rounded p-button-outlined p-ml-2" (click)="delete(data.id)"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="paginatorleft">
                    <p-button type="button" icon="pi pi-plus" styleClass="p-button-text" (onClick)="showAddNhanSu()">
                    </p-button>
                </ng-template>
                <ng-template pTemplate="paginatorright">
                    <p-button type="button" icon="pi pi-home" styleClass="p-button-text" (onClick)="homeUrlNav()">
                    </p-button>
                </ng-template>
            </p-table>
        </div>
    </p-panel>
</div>
<form novalidate [formGroup]="editFormGroup">
    <p-dialog [(visible)]="editNhanSuFlag" [draggable]="true" [style]="{width: '30vw'}" [modal]="true"
        [position]="position">
        <ng-template pTemplate="header">
            <h3>Sửa nhân sự</h3>
        </ng-template>
        <div class="p-fluid">
            <div class="p-field">
                <label for="hovaten">Họ và tên</label>
                <input id="hovaten" type="text" pInputText formControlName="hoVaTen">
            </div>
            <div class="p-field">
                <label for="lacongchungvien">Là công chứng viên?</label>
                <div class="p-mt-10">
                    <p-inputSwitch id="lacongchungvien" formControlName="laCongChungVien"></p-inputSwitch>
                </div>
            </div>
            <div class="p-field">
                <label for="username">Tài khoản đăng nhập</label>
                <input id="username" type="text" pInputText formControlName="username">
            </div>
            <div class="p-field">
                <label for="toanquyen">Tài khoản toàn quyền</label>
                <div class="p-mt-10">
                    <p-inputSwitch id="toanquyen" formControlName="toanquyen"></p-inputSwitch>
                </div>
            </div>
        </div>
        <p-footer>
            <button pButton pRipple type="button" label="Sửa" (click)="editNhanSu()"
                class="p-button-raised p-button-text"><i class="pi pi-save"></i>&nbsp;</button>
        </p-footer>
    </p-dialog>
</form>

<form novalidate [formGroup]="addFormGroup">
    <p-dialog [(visible)]="addNhanSuFlag" [draggable]="true" [style]="{width: '30vw'}" [modal]="true"
        [position]="position">
        <ng-template pTemplate="header">
            <h3>Thêm nhân sự</h3>
        </ng-template>
        <div class="p-fluid">
            <div class="p-field">
                <label for="hovaten">Họ và tên</label>
                <input id="hovaten" type="text" pInputText formControlName="hoVaTen">
            </div>
            <div class="p-field">
                <label for="lacongchungvien">Là công chứng viên?</label>
                <div class="p-mt-10">
                    <p-inputSwitch id="lacongchungvien" formControlName="laCongChungVien"></p-inputSwitch>
                </div>
            </div>
            <div class="p-field">
                <label for="username">Tài khoản đăng nhập</label>
                <input id="username" type="text" pInputText formControlName="username">
            </div>
            <div class="p-field">
                <label for="password">Mật khẩu</label>
                <input id="password" type="text" pInputText formControlName="password">
            </div>
            <div class="p-field">
                <label for="toanquyen">Tài khoản toàn quyền</label>
                <div class="p-mt-10">
                    <p-inputSwitch id="toanquyen" formControlName="toanquyen"></p-inputSwitch>
                </div>
            </div>
        </div>
        <p-footer>
            <button pButton pRipple type="button" label="Thêm" (click)="addNhanSu()"
                class="p-button-raised p-button-text"><i class="pi pi-save"></i>&nbsp;</button>
        </p-footer>
    </p-dialog>
</form>
<app-change-password (hideDialogEvent)="hideChangePassword($event)" [doiMatKhauFlag]="showChangePasswordFlag"
    [idUser]="currentIdUserSelected">
</app-change-password>
